import { Component, Input, OnInit } from "@angular/core";
import { MapObjectPipe } from "projects/sepidz-web-framework/src/lib/pipes/mapobject.pipe";
import { InvoiceHistory, InvoiceHistoryCompare, InvoiceItemHistory } from "src/app/frontoffice/order/model/invoicehistory.model";
import { ShowToastrService } from "../../../../../../projects/sepidz-web-framework/src/lib/services";
import { HttpCommonService } from "../../../../../../projects/sepidz-web-framework/src/lib/services/http-common.service";
import { SecurityReviewService } from "../security-review.service";
import { take } from "rxjs/operators";
import { ClearEnum, DeliveryEnum, MealEnum } from "src/app/frontoffice/catalog/model/deposit.enum";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { DepositChangedFieldEnum } from "src/app/frontoffice/catalog/model/deposit.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "detail-security-review",
  templateUrl: "./detail-security-review.component.html",
  styleUrls: ["./detail-security-review.component.scss"],
})
export class DetailSecurityReviewComponent implements OnInit {
  showHeaderContent: boolean = false;
  showDepositHeaderContent: boolean = false;
  showFooterContent: boolean = false;
  changeFactor: boolean = false;
  DeleteList: InvoiceItemHistory[] = [];

  mealTimeEnum = MealEnum;
  clearTypeEnum = ClearEnum;
  deliveryTypeEnum = DeliveryEnum;
  stateEnum = RowState;
  changedFieldCodeEnum = DepositChangedFieldEnum;

  @Input() CompareList: InvoiceHistoryCompare[];
  @Input() IsDelino: boolean = false;
  AllInvoice: InvoiceHistory[];
  stateFilter: any[] = [
    { key: 1, title: this.translate.instant("ClientApp.FrontOffice.Review.SecurityReview.TemporaryRegistration"), count: 0, selected: false },
    { key: 2, title: this.translate.instant("ClientApp.FrontOffice.Review.SecurityReview.PrintingAndPreparation"), count: 0, selected: false },
    { key: 3, title: this.translate.instant("ClientApp.FrontOffice.Review.SecurityReview.KitchenPrint"), count: 0, selected: false },
    { key: 4, title: this.translate.instant("ClientApp.FrontOffice.Review.SecurityReview.DedicatedToCourier"), count: 0, selected: false },
  ];
  constructor(
    private sts: ShowToastrService,
    public securityService: SecurityReviewService,
    private httpCommonService: HttpCommonService,
    private translate: TranslateService
  ) {}

  FillData() {
    this.httpCommonService
      .get(`SecurityReview/SecurityReviewDetails/${this.securityService.CompareList[0].InvoiceId}`)
      .pipe(take(1))
      .subscribe(
        (data: any) => {
          this.AllInvoice = data;
          this.CompareList = [];
          this.AllInvoice.forEach((el) => {
            if (el.DepositHistory?.Changes) el.DepositHistory.Changes = JSON.parse(el.DepositHistory.Changes as any);
            if (this.securityService.CompareList.some((f) => f.Id === el.Id)) {
              el.selected = true;
              let output = new InvoiceHistory();
              let mapper = new MapObjectPipe();
              const history = JSON.parse(JSON.stringify(mapper.transform(el, output)));
              this.CompareList.push(history);
            }
          });
          this.CompareList.sort((a, b) => {
            return a.Code - b.Code;
          });
          this.checkChange();
        },
        (error) => {
          console.log(error);
        }
      );
  }
  ngOnInit(): void {
    this.FillData();
  }
  changeCompare(invoice: InvoiceHistory) {
    const findItemIndex = this.AllInvoice.findIndex((f) => f.Id === invoice.Id);
    this.AllInvoice[findItemIndex].selected = !this.AllInvoice[findItemIndex].selected;
    this.CompareList = [];
    this.AllInvoice.forEach((el) => {
      if (el.selected) {
        el.selected = true;
        let output = new InvoiceHistory();
        let mapper = new MapObjectPipe();
        const history = JSON.parse(JSON.stringify(mapper.transform(el, output)));
        this.CompareList.push(history);
      }
    });
    this.checkChange();
  }
  checkChange() {
    try {
      if (!this.CompareList || this.CompareList.length < 2) return;
      for (let index = 1; index <= this.CompareList.length - 1; index++) {
        /// tax
        if (this.CompareList[index].TotalTax > this.CompareList[index - 1].TotalTax) {
          this.CompareList[index].TotalTaxup = true;
        }
        if (this.CompareList[index].TotalTax < this.CompareList[index - 1].TotalTax) {
          this.CompareList[index].TotalTaxDown = true;
        }
        /// service
        if (this.CompareList[index].TotalService > this.CompareList[index - 1].TotalService) {
          this.CompareList[index].TotalServiceup = true;
        }
        if (this.CompareList[index].TotalService < this.CompareList[index - 1].TotalService) {
          this.CompareList[index].TotalServiceDown = true;
        }
        /// DiscountPrice
        if (this.CompareList[index].DiscountPrice > this.CompareList[index - 1].DiscountPrice) {
          this.CompareList[index].TotalDiscountup = true;
        }
        if (this.CompareList[index].DiscountPrice < this.CompareList[index - 1].DiscountPrice) {
          this.CompareList[index].TotalDiscountDown = true;
        }
        /// ShipingCost
        if (this.CompareList[index].ShippingCost > this.CompareList[index - 1].ShippingCost) {
          this.CompareList[index].ShippingCostup = true;
        }
        if (this.CompareList[index].ShippingCost < this.CompareList[index - 1].ShippingCost) {
          this.CompareList[index].ShippingCostDown = true;
        }
        /// PackingPrice
        if (this.CompareList[index].PackingPrice > this.CompareList[index - 1].PackingPrice) {
          this.CompareList[index].PackingPriceup = true;
        }
        if (this.CompareList[index].PackingPrice < this.CompareList[index - 1].PackingPrice) {
          this.CompareList[index].PackingPriceDown = true;
        }
        /// PayableTotal
        if (this.CompareList[index].PayableTotal > this.CompareList[index - 1].PayableTotal) {
          this.CompareList[index].PayableTotalup = true;
        }
        if (this.CompareList[index].PayableTotal < this.CompareList[index - 1].PayableTotal) {
          this.CompareList[index].PayableTotalDown = true;
        }
        /// Total
        if (this.CompareList[index].Total > this.CompareList[index - 1].Total) {
          this.CompareList[index].Totalup = true;
        }
        if (this.CompareList[index].Total < this.CompareList[index - 1].Total) {
          this.CompareList[index].TotalDown = true;
        }
        /// Debit
        if (this.CompareList[index].Debit > this.CompareList[index - 1].Debit) {
          this.CompareList[index].Debitup = true;
        }
        if (this.CompareList[index].Debit < this.CompareList[index - 1].Debit) {
          this.CompareList[index].DebitDown = true;
        }
        /// Credit
        if (this.CompareList[index].Credit > this.CompareList[index - 1].Credit) {
          this.CompareList[index].Creditup = true;
        }
        if (this.CompareList[index].Credit < this.CompareList[index - 1].Credit) {
          this.CompareList[index].CreditDown = true;
        }
        ///
        if (this.CompareList[index].Description !== this.CompareList[index - 1].Description) {
          this.CompareList[index].DescriptionChange = true;
        }
        if (index > 0) {
          this.CompareList[index - 1].Items.forEach((f) => {
            const deletedItem =
              this.CompareList[index].Items.some((s) => s.Index == f.Index && s.ItemId === f.ItemId) &&
              !this.DeleteList.some((s) => s.Index == f.Index && s.ItemId === f.ItemId);
            if (!deletedItem) {
              const tempItem = Object.assign({}, f);
              tempItem.Index = f.Index;
              tempItem.ItemTitle = null;
              this.DeleteList.push(tempItem);
              this.CompareList[index].Items.push(tempItem);
              this.CompareList[index].Items = this.CompareList[index].Items.sort((a, b) => a.Index - b.Index);
            }
          });
        }
        for (var i = 0; i < this.CompareList[index].Items.length; i++) {
          if (
            this.CompareList[index]?.Items?.find((f) => f.Index == i)?.ItemId &&
            this.CompareList[index - 1]?.Items?.find((f) => f.Index == i)?.ItemId &&
            this.CompareList[index]?.Items?.find((f) => f.Index == i)?.ItemId ===
              this.CompareList[index - 1]?.Items?.find((f) => f.Index == i)?.ItemId &&
            this.CompareList[index]?.Items?.find((f) => f.Index == i).Index === this.CompareList[index - 1]?.Items?.find((f) => f.Index == i).Index
          ) {
            if (
              this.CompareList[index]?.Items?.find((f) => f.Index == i).Quantity >
              this.CompareList[index - 1]?.Items?.find((f) => f.Index == i).Quantity
            ) {
              this.CompareList[index].Items.find((f) => f.Index == i).QuantityUp = true;
            }
            if (
              this.CompareList[index]?.Items?.find((f) => f.Index == i)?.Description !==
                this.CompareList[index - 1]?.Items?.find((f) => f.Index == i)?.Description ||
              this.CompareList[index]?.Items?.find((f) => f.Index == i)?.Description !==
                this.CompareList[index - 1]?.Items?.find((f) => f.Index == i)?.Description
            ) {
              this.CompareList[index].Items.find((f) => f.Index == i).DescriptionChange = true;
              this.CompareList[index - 1].Items.find((f) => f.Index == i).DescriptionChange = true;
            }
            if (
              this.CompareList[index]?.Items?.find((f) => f.Index == i).Quantity <
              this.CompareList[index - 1]?.Items?.find((f) => f.Index == i)?.Quantity
            ) {
              this.CompareList[index].Items.find((f) => f.Index == i).QuantityDown = true;
            }
            if (
              this.CompareList[index]?.Items?.find((f) => f.Index == i)?.RowDiscountPrice >
              this.CompareList[index - 1]?.Items?.find((f) => f.Index == i)?.RowDiscountPrice
            ) {
              this.CompareList[index].Items.find((f) => f.Index == i).RowDiscountPriceUP = true;
            }
            if (
              this.CompareList[index]?.Items?.find((f) => f.Index == i).RowDiscountPrice <
              this.CompareList[index - 1]?.Items?.find((f) => f.Index == i)?.RowDiscountPrice
            ) {
              this.CompareList[index].Items.find((f) => f.Index == i).RowDiscountPriceDown = true;
            }
            if (
              this.CompareList[index]?.Items?.find((f) => f.Index == i).TotalPrice >
              this.CompareList[index - 1]?.Items?.find((f) => f.Index == i)?.TotalPrice
            ) {
              this.CompareList[index].Items.find((f) => f.Index == i).TotalPriceUp = true;
            }
            if (
              this.CompareList[index]?.Items?.find((f) => f.Index == i).TotalPrice <
              this.CompareList[index - 1]?.Items?.find((f) => f.Index == i).TotalPrice
            ) {
              this.CompareList[index].Items.find((f) => f.Index == i).TotalPriceDown = true;
            }
          }
        }
      }
    } catch (error) {
      console.log(`In Change Check Has Error`);
    }
  }
}
